export default {
  HIOPOSWEBSERVICES: 'https://hiopos.saas.com.co/api/ec/v1',
  LOGS_URL: 'https://hiopos.saas.com.co/logs/ecuador',
  HIOPOSWEBSERVICESCOMBINED: 'https://hiopos.saas.com.co',
  HIOPOSREPORTSEC: 'https://hioposreports-ec.saas.com.co',
}
